import React, { useState, useRef, useEffect } from "react";
import "./home.css";
import { Button } from "semantic-ui-react";
import { Noise } from "noisejs";
import JoinCsaForm from "../components/layout/JoinCsaForm";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import PlayersToWatch from "../components/layout/PlayersToWatch";
import {
  bubbles,
  canvasWidth,
  noiseAmount,
  noiseSpeed,
  scrollSpeed,
} from "../utils/utils";
const video = "https://www.youtube.com/watch?v=gzIAGuafOpM";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [joinCsaClicked, setJoinCsaClicked] = useState(false);
  const handleButtonClick = () => {
    if (isVisible) {
      setIsVisible(false);
      setJoinCsaClicked(true);
    } else {
      setJoinCsaClicked(true);
    }
  };

  const handleJoinCsaClose = () => {
    setJoinCsaClicked(false);
  };

  const joinCsaButton = (
    <Button
      positive
      size="large"
      name="joinCsaButton"
      onClick={handleButtonClick}
    >
      Contact CSA!
    </Button>
  );

  var backgroundPositions = [];

  for (let i = 0; i < 6; i++) {
    for (let j = 0; j < 6; j++) {
      backgroundPositions.push(`${-154 * j}px ${-154 * i}px`);
    }
  }

  const noise = new Noise();

  const animationRef = useRef(0);

  const bubblesRef = useRef(
    bubbles.map((bubble) => ({
      ...bubble,
      noiseSeedX: Math.floor(Math.random() * 64000),
      noiseSeedY: Math.floor(Math.random() * 64000),
      xWithNoise: bubble.x,
      yWithNoise: bubble.y,
    }))
  );

  const [isReady, setReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 200);

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  function animate() {
    bubblesRef.current = bubblesRef.current.map((bubble, index) => {
      const newNoiseSeedX = bubble.noiseSeedX + noiseSpeed;
      const newNoiseSeedY = bubble.noiseSeedY + noiseSpeed;

      const randomX = noise.simplex2(newNoiseSeedX, 0);
      const randomY = noise.simplex2(newNoiseSeedY, 0);

      const newX = bubble.x - scrollSpeed;

      const newXWithNoise = newX + randomX * noiseAmount;
      const newYWithNoise = bubble.y + randomY * noiseAmount;

      const element = document.getElementById(`Bubble-${index}`);

      if (element) {
        element.style.transform = `translate(${newXWithNoise}px, ${newYWithNoise}px) scale(${bubble.s})`;
      }

      return {
        ...bubble,
        noiseSeedX: newNoiseSeedX,
        noiseSeedY: newNoiseSeedY,
        x: newX < -200 ? canvasWidth : newX,
        xWithNoise: newXWithNoise,
        yWithNoise: newYWithNoise,
      };
    });

    animationRef.current = requestAnimationFrame(animate);
  }

  return (
    <>
      <div className="HomeContainer">
        <div className="Hero">
          <ReactPlayer
            className="reactPlayer"
            playing
            muted
            loop
            playsinline
            url={video}
            width="100%"
            height="100%"
          />
        </div>
        <div className="HomeAboutContainer">
          <h3>Start Your Journey Today</h3>
          <p>
            Developing individual paths for Student Athletes to play in College.
            It's more than recruiting. We're Mentors, Advocates, and Life
            Coaches!
          </p>
          {joinCsaButton}
          <JoinCsaForm
            joinCsa={joinCsaClicked}
            joinCsaClose={handleJoinCsaClose}
          />
        </div>
        <div className="HomeSkillContainer">
          <div className="HomeSkillBanner">
            <h3>Players To Watch</h3>
          </div>
          <PlayersToWatch />
        </div>
        <div className="HomeCommittedContainer">
          <div className="HomeCommittedBanner">
            <h3>Commitments</h3>
          </div>
          <Link to="/commitments">
            <div className="Bubbles-wrapper">
              <div className="Bubbles">
                {bubbles.map((bubble, index) => (
                  <div
                    className="Bubble"
                    id={`Bubble-${index}`}
                    key={`${bubble.x} ${bubble.y}`}
                    style={{
                      backgroundPosition: backgroundPositions[index],
                      opacity: isReady ? 1 : 0,
                      transform: `translate(${bubble.x}px, ${bubble.y}px) scale(${bubble.s})`,
                    }}
                  />
                ))}
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Home;
